import ShopTaxedPriceModelBase from '../_generated/modelBases/shop-taxed-price-model-base';

export default class ShopTaxedPriceModel extends ShopTaxedPriceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
